<template>
  <section class="arrivals" aria-labelledby="arrivals-title">
    <div class="arrivals__head">
      <div>
        <p class="eyebrow">Just in</p>
        <h2 id="arrivals-title">New Arrivals</h2>
      </div>
      <router-link to="/collections/new-arrivals" class="arrivals__all">Shop all</router-link>
    </div>

    <ProductGrid v-if="products.length" :products="products" :fill="8" />
    <PlaceholderGrid v-else-if="!loading" :count="8" />
  </section>
</template>

<script>
import { fetchProducts } from '../../shopify/products'
import ProductGrid from '../ProductGrid.vue'
import PlaceholderGrid from '../PlaceholderGrid.vue'

export default {
  name: 'NewArrivals',

  components: { ProductGrid, PlaceholderGrid },

  data() {
    return {
      products: [],
      loading: true,
    }
  },

  // The 8 newest products across the whole store, whatever collection
  // they're in; empty slots are padded with placeholder cards.
  async mounted() {
    try {
      this.products = await fetchProducts(8)
    } catch {
      this.products = []
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.arrivals {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 10rem 4rem;
}

.arrivals__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 4rem;
}

.arrivals__head h2 {
  font-size: clamp(3.4rem, 4vw, 4.8rem);
  font-weight: 400;
  margin-top: 0.8rem;
}

.arrivals__all {
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink);
  border-bottom: 1px solid var(--ink);
  padding-bottom: 2px;
}
.arrivals__all:hover { color: var(--amber); border-color: var(--amber); }

@media (max-width: 960px) {
  .arrivals { padding: 6.4rem 1.6rem; }
}
</style>
